<div class="espaco">
  <div class="conteudo" [ngStyle]="{'background-image':'url('+ fundoImg +')'}">
    <div class="login">
      <h1>Login</h1>
      <div *ngIf="error" class="alert alert-danger">
        {{error}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form name="form" (ngSubmit)="f.form.valid && logon()" #f="ngForm" novalidate>
        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
          <input type="text" class="form-control" placeholder="Login" name="username" [(ngModel)]="model.username"
            #username="ngModel" required />
          <div *ngIf="f.submitted && !username.valid" class="help-block">Login é necessário</div>
        </div>
        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
          <input type="password" class="form-control" placeholder="Senha" name="password" [(ngModel)]="model.password"
            #password="ngModel" required />
          <div *ngIf="f.submitted && !password.valid" class="help-block">Senha é necessária</div>
        </div>
        <div class="form-group">
          <button [disabled]="loading" class="btn btn-primary btn-block btn-large btn-open">
            Entrar
          </button>
        </div>
        <app-loading [exibir]="loading"></app-loading>
      </form>
      <br>
      <input type="checkbox" id="check" />
      <label for="check" class="redefinirSenha" (click)="displayEmail=true">
        Redefinir Senha
      </label>
      <script>
        (adsbygoogle = window.adsbygoogle || []).push({});
      </script>
    </div>
  </div>

  <p-dialog header="Código de Verificação" [(visible)]="displayCodigo">
    Um código de verificação de seis dígitos acabou de ser enviado para o email: <strong>{{emailEnvio}}</strong>.<br>
    Insira abaixo e clique em Ok.<br><br>
    <div *ngIf="errorCodigo" class="alert alert-danger">{{errorCodigo}}</div>
    <p-inputNumber [(ngModel)]="model.codigo" [useGrouping]="false"></p-inputNumber><br><br>
    <p-checkbox [binary]="true" [(ngModel)]="checkbox" label="Confiar neste dispositivo?"></p-checkbox>
    <ng-template pTemplate="footer">
      <button pButton icon="pi pi-send" style="position:absolute; left: 19px;" (click)="reenviarCodigo()" label="Reenviar código" [loading]="loadingCodigo"></button>
      <button pButton icon="pi pi-ban" (click)="cancelarCodigo()" label="Cancelar" class="p-button-secondary"></button>
      <button pButton icon="pi pi-check" (click)="enviaCodigo()" label="Ok"></button>
    </ng-template>
  </p-dialog>

  <p-dialog header="Redefinir Senha" [(visible)]="displayEmail">
    Digite o nome do usuário que deverá receber o email para a redefinição de senha.<br><br>
    <div *ngIf="errorEmail" class="alert alert-danger">{{errorEmail}}</div>
    <input id="float-input" type="text" placeholder="Usuário" pInputText [(ngModel)]="model.user">
    <ng-template pTemplate="footer">
      <button pButton icon="pi pi-ban" (click)="cancelarCodigo()" label="Cancelar" class="p-button-secondary"></button>
      <button pButton icon="pi pi-send" (click)="enviarEmail()" label="Enviar Email"></button>
    </ng-template>
  </p-dialog>
</div>